import { setDocumentInUserContext } from '../../firebase/document/documentSagas';
import { DOCTORS_PREFERENCES } from '../../../shared/collection/collectionConstants';

export default class UpsertDoctorToFavoritesUseCase {
  static *upsert(failureCallback, action) {
    yield* setDocumentInUserContext(DOCTORS_PREFERENCES, failureCallback, action);
  }
}
